import { render, staticRenderFns } from "./AppSignupOneTimePassConfirmPane.vue?vue&type=template&id=b9e18c30&scoped=true"
import script from "./AppSignupOneTimePassConfirmPane.vue?vue&type=script&lang=ts"
export * from "./AppSignupOneTimePassConfirmPane.vue?vue&type=script&lang=ts"
import style0 from "./AppSignupOneTimePassConfirmPane.vue?vue&type=style&index=0&id=b9e18c30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e18c30",
  null
  
)

export default component.exports